// GENERATED by scripts/icons/generate_icons.py. Do not edit by hand.
import { createIcon } from "./createIcon";

export const ProhibitedIcon = /*#__PURE__*/ createIcon("Prohibited", "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-1 0c0-1.75-.64-3.36-1.7-4.58l-9.88 9.87A7 7 0 0 0 17 10M4.7 14.58l9.88-9.87a7 7 0 0 0-9.87 9.87");
